import React from "react";
import ReactDOM from "react-dom";
import firebase from "firebase";
import FileUploader from "react-firebase-file-uploader";
import NotchedOutline from "@material-ui/core/OutlinedInput/NotchedOutline";
import { useState } from "react";
import { makeStyles, InputLabel } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles((theme) => ({
  button: {
    cursor: "pointer",
  },

  root: {
    position: "relative",
    paddingTop: "0px",
    display: "flex",
    alignItems: "top",
  },
  content: {
    padding: "18.5px 14px",
  },
  inputLabel: {
    position: "absolute",
    left: 0,
    top: 0,
    // slight alteration to spec spacing to match visual spec result
    transform: "translate(0, 24px) scale(1)",
  },
}));

const PdfUpload = ({ reportId, setter, pdf, label, id }) => {
  const [labelWidth, setLabelWidth] = React.useState(0);
  const labelRef = React.useRef(null);
  React.useEffect(() => {
    const labelNode = ReactDOM.findDOMNode(labelRef.current);
    setLabelWidth(labelNode != null ? labelNode.offsetWidth : 0);
  }, [label]);
  const classes = useStyles();
  const [file, setFile] = useState(pdf ? pdf : { name: "", url: "" });
  const [status, setStatus] = useState({
    isUploading: false,
    progress: 0,
    error: "",
  });
  const handleUploadStart = () => setStatus({ isUploading: true, progress: 0 });
  const handleProgress = (progress) =>
    setStatus({ isUploading: true, progress });
  const handleUploadError = (error) => {
    setStatus({ isUploading: false, error: error });
  };
  const handleUploadSuccess = (filename) => {
    firebase
      .storage()
      .ref("pdfs")
      .child(reportId)
      .child(filename)
      .getDownloadURL()
      .then((url) => {
        setFile({ name: filename, url: url });
        setter({ name: filename, url: url });
        setStatus({ isUploading: false, progress: 100 });
      });
  };
  const handleDelete = () => {
    firebase
      .storage()
      .ref("pdfs")
      .child(reportId)
      .child(file.name)
      .delete()
      .then(() => {
        setFile({ name: "", url: "" });
        setter({ name: "", url: "" });
      });
  };
  return (
    <div style={{ position: "relative", marginTop: "8px" }}>
      <InputLabel
        ref={labelRef}
        htmlFor={id}
        variant="outlined"
        className={classes.inputLabel}
        shrink
      >
        {label}
      </InputLabel>
      <div className={classes.root}>
        <div id={id} className={classes.content}>
          {file.url ? (
            <div style={{ display: "flex", alignItems: "middle" }}>
              <a href={file.url} target="_blank" rel="noopener noreferrer">
                {file.name}
              </a>
              <DeleteIcon onClick={handleDelete} className={classes.button} />
            </div>
          ) : status.isUploading ? (
            <p>Wird hochgeladen: {status.progress} %</p>
          ) : (
            <label
              style={{
                backgroundColor: "steelblue",
                color: "white",
                padding: 10,
                borderRadius: 4,
                cursor: "pointer",
              }}
            >
              Hochladen
              <FileUploader
                hidden
                accept="application/pdf"
                filename={(file) => file.name}
                storageRef={firebase.storage().ref("pdfs/" + reportId)}
                onUploadStart={handleUploadStart}
                onUploadError={handleUploadError}
                onUploadSuccess={handleUploadSuccess}
                onProgress={handleProgress}
              />
            </label>
          )}
          <NotchedOutline notched labelWidth={labelWidth} />
        </div>
      </div>
    </div>
  );
};

export default PdfUpload;
